import React from 'react';
import ReactDOM from 'react-dom/client';
import Login from './Login';
import CreateMeetings from './CreateMeetings';
import  {BrowserRouter , Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import MeetingNotesPage from './MeetingNotesPage';
import Register from './Register';
import  ProtectedRoute  from './ProtectedRoute';
import About from './About';
import Search from './Search';
import ExpandedSearchResult from './ExpandedSearchResult';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>

      <Route path="/Login" element={ <Login /> } />
      <Route path="/Register" element={ <Register /> } />
      <Route path="/About" element={ <About /> } />
      <Route path="/" element={ <ProtectedRoute> <CreateMeetings /> </ProtectedRoute> } />
      <Route path="/meetingNotes" element={ <ProtectedRoute> <MeetingNotesPage /> </ProtectedRoute>} />
      <Route path="/Search" element={ <ProtectedRoute> <Search /> </ProtectedRoute>} />
      <Route path="/ExpandedSearchResult" element={ <ProtectedRoute> <ExpandedSearchResult /> </ProtectedRoute>} />
      <Route path="*" element={ <h1>Not Found</h1> } />
    </Routes>
  </BrowserRouter>

);

reportWebVitals();
